/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import KeyInformationDetailsItemModal from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItemModal';
import { KIM_MOBILE_SUBTITLE_DISPLAY_OPTIONS } from 'bundles/unified-description-page-common/constants';

const styles = {
  container: css`
    display: flex;
  `,
  title: css`
    padding-right: var(--cds-spacing-100);
  `,
};

type Props = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  subtitleDisplayOption?: (typeof KIM_MOBILE_SUBTITLE_DISPLAY_OPTIONS)[keyof typeof KIM_MOBILE_SUBTITLE_DISPLAY_OPTIONS];
  modalTitle?: React.ReactNode;
};

const KeyInformationDetailsMobileItem = ({ title, subtitle, subtitleDisplayOption, modalTitle }: Props) => {
  switch (subtitleDisplayOption) {
    case KIM_MOBILE_SUBTITLE_DISPLAY_OPTIONS.DISPLAY_INLINE:
      return (
        <div css={styles.container}>
          <Typography2 css={styles.title} variant="subtitleLarge" component="div">
            {title}
          </Typography2>
          {subtitle}
        </div>
      );
    case KIM_MOBILE_SUBTITLE_DISPLAY_OPTIONS.NO_SUBTITLE:
      return (
        <div css={styles.container}>
          <Typography2 css={styles.title} variant="subtitleLarge" component="div">
            {title}
          </Typography2>
        </div>
      );
    case KIM_MOBILE_SUBTITLE_DISPLAY_OPTIONS.DISPLAY_SUBTITLE_ONLY:
      return <React.Fragment>{subtitle}</React.Fragment>;
    case KIM_MOBILE_SUBTITLE_DISPLAY_OPTIONS.DISPLAY_IN_MODAL:
    default:
      return <KeyInformationDetailsItemModal title={title} subtitle={subtitle} modalTitle={modalTitle} />;
  }
};

export default KeyInformationDetailsMobileItem;
